import React from 'react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/input';

// One availability time range. Empty start/end = all day.
export const TimeRange = ({ e, onChange, onRemove, typeSelect, testId }) => {
  const allDay = !e.start && !e.end;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      {typeSelect && (
        <select value={e.type} onChange={ev => onChange({ type: ev.target.value })} data-testid={`${testId}-type`}
          className={`h-9 rounded-md border px-2 text-sm font-semibold ${e.type === 'available' ? 'text-emerald-700' : 'text-red-700'}`}>
          <option value="available">Available</option>
          <option value="unavailable">Unavailable</option>
        </select>
      )}
      <label className="flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer">
        <input type="checkbox" className="accent-[#00247D]" checked={allDay} data-testid={`${testId}-allday`}
          onChange={ev => onChange(ev.target.checked ? { start: '', end: '' } : { start: '09:00', end: '17:00' })} />
        All day
      </label>
      {!allDay && (
        <>
          <Input type="time" value={e.start} onChange={ev => onChange({ start: ev.target.value })} className="h-9 w-[7.5rem]" data-testid={`${testId}-start`} />
          <span className="text-slate-400 text-sm">to</span>
          <Input type="time" value={e.end} onChange={ev => onChange({ end: ev.target.value })} className="h-9 w-[7.5rem]" data-testid={`${testId}-end`} />
        </>
      )}
      <button type="button" onClick={onRemove} className="p-1.5 rounded text-slate-400 hover:text-red-600 hover:bg-red-50" data-testid={`${testId}-remove`}>
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
